export default {
    'grapesjs-plugin-thumbai': {
        block: {
            label: 'AI image',
            category: 'Basic',
            placeholderText: 'AI Image',
            placeholderSrcTemplate: 'https://placehold.co/640x360/111/fff?text={text}',
        },
        toolbar: {
            label: 'AI',
            title: 'ThumbAI',
        },
        prompts: {
            placeholder: 'Add any extra creative direction (optional)',
        },
        labels: {
            section: 'Image AI',
            prompt: 'Prompt override',
            paramsHeading: 'Template parameters',
            paramsDefaultLabel: 'Parameter {index}',
            button: 'Generate',
            generateAction: 'Generate with AI',
            traitButton: 'Generate with AI',
            save: 'Save settings',
            saved: 'Settings saved',
            serviceLoaded: 'Template updated',
            modalTitle: 'Generate Image',
            modalHeading: 'Generate Image',
            modalSubheading: 'Choose an AI service, adjust the template inputs, and generate a fresh visual instantly.',
            service: 'AI service',
            servicePlaceholder: 'Choose a service',
            selectService: 'Pick a service to see the template inputs.',
            modalLoading: 'Loading AI settings…',
            loading: 'Generating…',
            success: 'New image applied',
            error: 'Generation failed',
            missingCredentials: 'ThumbAI API token or user ID missing',
            missingPromptId: 'Prompt ID missing for this service',
            missingParams: 'Please fill every AI parameter before generating',
            missingService: 'Select a service before generating',
            missingImage: 'ThumbAI did not return an image',
            base64ConversionFailed: 'ThumbAI image could not be converted to base64',
            uploadError: 'ThumbAI upload failed',
            noParams: 'This service has no additional parameters.',
            loadServiceError: 'Unable to load service',
            serviceInfoError: 'Unable to load ThumbAI service info',
            traitSuccess: 'New image applied',
            traitError: 'Generation failed',
            toolbarTitle: 'ThumbAI',
        },
        services: {
            'blog-post-thumbnail': 'Blog Post Thumbnail',
            'e-commerce-product-ad': 'E-Commerce Product Ad',
            'event-promotion-poster': 'Event Promotion Poster',
            'facebook-feed-ads': 'Facebook Feed Ads',
            'facebook-reels': 'Facebook Reels',
            'fiverr-gig': 'Fiverr Gig',
            'instagram-reels': 'Instagram Reels',
            'instagram-story-ad': 'Instagram Story Ad',
            'linkedin-ads': 'LinkedIn Ads',
            'logo-design': 'Logo Design',
            'podcast-cover-art': 'Podcast Cover Art',
            'portfolio-showcase-thumbnail': 'Portfolio Showcase Thumbnail',
            'spotify-playlist-cover': 'Spotify Playlist Cover',
            'startup-landing-page-banner': 'Startup Landing Page Banner',
            'tiktok-profile': 'TikTok Profile',
            'tiktok-video-covers': 'TikTok Video Covers',
            'twitch-stream-thumbnail': 'Twitch Stream Thumbnail',
            'upwork-gig': 'Upwork Gig',
            'youtube-gaming-thumbnail': 'YouTube Gaming Thumbnail',
            'youtube-thumbnails': 'YouTube Thumbnails',
        },
        params: {
            entries: {
                param1: {
                    label: 'Your Logo Subject',
                    placeholder: 'e.g., rocket, star, gear',
                },
                param2: {
                    label: 'YOUR TITLE HERE',
                    placeholder: 'YOUR TITLE HERE',
                },
            },
        },
    },
};